{
  "batteryCharge": {
    "legendWithUnitLabel": "Carica della batteria interna ({{unitLabel}})"
  },
  "batteryGraph": {
    "legend": "Tensione di ingresso (V)"
  },
  "dailyVolumeWithUnitLabel": "Volume giornaliero (k{{unitLabel}})",
  "linkTo": "Analisi",
  "title": "Analisi dei dispositivi",
  "waterUsage": {
    "graph": {
      "legend": "Volume giornaliero"
    }
  }
}
